import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import WenxianList from "./WenxianList";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import SERVER_ADDRESS from "../../../../config";
import { EditWenxianDialogButton } from "../../utils";
const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },

  divider: {
    marginBottom: theme.spacing(1)
  },

  typography: {
    marginTop: theme.spacing(4)
  },
  paper: {
    width: "100%",
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2)
  }
}));

function useWenxians(initValue, fetchUrl) {
  const [wenxians, setWenxians] = useState(initValue);
  useEffect(() => {
    // const abortController = new AbortController();
    // const signal = abortController.signal;
    fetch(fetchUrl, {
      // signal: signal,
      mode: "cors",
      credentials: "include"
    })
      .then(res => {
        return res.json();
      })
      .then(data => {
        setWenxians(data);
        return null;
      });
    // return () => {
    //   abortController.abort();
    // };
  }, []);

  //freshData
  const freshData = (data, method = "update", deleteId) => {
    if (method === "update") {
      setWenxians((prevWenxians, props) => {
        const newWenxians = [];
        prevWenxians.forEach(wenxian => {
          newWenxians.push(wenxian.id === data.id ? data : wenxian);
        });
        return newWenxians;
      });
    }
    if (method === "delete") {
      setWenxians((prevWenxians, props) => {
        const newWenxians = [];
        prevWenxians.forEach(wenxian => {
          if (wenxian.id !== deleteId) {
            newWenxians.push(wenxian);
          }
        });
        return newWenxians;
      });
    }
    if (method === "add") {
      setWenxians([...wenxians, data]);
    }
  };
  return { wenxians, freshData };
}

function WenxianPage(props) {
  const classes = useStyles();
  let queryUrl = `${SERVER_ADDRESS}/api/wenxians.json/`;

  //参考文献
  const { wenxians, freshData } = useWenxians([], queryUrl);

  return (
    <Grid container className={classes.paper} component={Paper} spacing={1}>
      <Grid item xs={12}>
        <Typography
          variant="h5"
          gutterBottom
          color="secondary"
          className={classes.typography}
        >
          参考文献
          <EditWenxianDialogButton
            buttonText="新建参考文献"
            freshData={data => {
              freshData(data, "add");
            }}
            add
          />
        </Typography>
        <Divider variant="fullWidth" className={classes.divider} />
      </Grid>

      <Grid item xs={12}>
        <WenxianList wenxians={wenxians} freshData={freshData} />
      </Grid>
    </Grid>
  );
}

export default WenxianPage;
